import { css } from 'styled-components'
import {
  ANATOMY_COMPACT,
  anatomyCompact,
} from '~/pages/anatomy/libs/responsive'
import { COLORS } from '~/shared/constants/uiConstants'

export const anatomyRootCss = css`
  width: 100%;
  height: calc(100dvh - var(--header-height));
  overflow: hidden;

  &::before {
    position: absolute;
    z-index: -1;
    inset: 0;
    content: '';
    background-color: ${COLORS.GRAY_100};
  }

  ${anatomyCompact} {
    overflow-y: auto;
  }
`

export const anatomyContainerCss = css`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const anatomyH1Css = css`
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  color: ${COLORS.BLACK};

  ${anatomyCompact} {
    font-size: ${ANATOMY_COMPACT.fontSize.f22};
    line-height: ${ANATOMY_COMPACT.lineHeight.lh28};
  }
`

export const anatomyBodyCss = css`
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.BLACK};
`

export const anatomyStickyButtonCss = css`
  margin-top: auto;
`
